export default __webpack_public_path__ + "static/lowenfels1-6619506f15d1851ef5fddf0d6892bc78.png";